import React from 'react';

export function Information(props) {
    return (
        <div style={{ border: "2px solid #c3c3c3", padding: "8px", borderRadius: "5px", color: "#666", textAlign: "left", marginBottom: "30px", ...props.style }}>
            <i className="fas fa-info-circle" /> &nbsp;{props.children}
        </div>
    )
}
Information.defaultProps = {
    style: {}
}


// WEBPACK FOOTER //
// ./src/components/GenericComponets/Information.js